module.exports = __webpack_public_path__ + "img/featured.c7d9a8d7.jpg";